var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenewalMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "22px",
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-report-1053720") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-32.000000, -251.000000)",
    fill: "#435971",
    fillRule: "nonzero",
    stroke: "#435971",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Menu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(17.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-3",
    transform: "translate(16.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-report-1053720"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0219298246,0.0219298246 L14.6052632,0.0219298246 L14.6052632,19.9780702 L0.0219298246,19.9780702 L0.0219298246,0.0219298246 Z M0.789473684,19.2105263 L13.8377193,19.2105263 L13.8377193,0.789473684 L0.789473684,0.789473684 L0.789473684,19.2105263 Z M3.09210526,3.85964912 L11.5350877,3.85964912 L11.5350877,4.62719298 L3.09210526,4.62719298 L3.09210526,3.85964912 Z M3.09210526,6.1622807 L11.5350877,6.1622807 L11.5350877,6.92982456 L3.09210526,6.92982456 L3.09210526,6.1622807 Z M3.09210526,8.46491228 L11.5350877,8.46491228 L11.5350877,9.23245614 L3.09210526,9.23245614 L3.09210526,8.46491228 Z M3.09210526,10.7675439 L11.5350877,10.7675439 L11.5350877,11.5350877 L3.09210526,11.5350877 L3.09210526,10.7675439 Z M3.09210526,13.0701754 L11.5350877,13.0701754 L11.5350877,13.8377193 L3.09210526,13.8377193 L3.09210526,13.0701754 Z M3.09210526,15.372807 L11.5350877,15.372807 L11.5350877,16.1403509 L3.09210526,16.1403509 L3.09210526,15.372807 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalMenu);
export default __webpack_public_path__ + "static/media/Renewal-menu.278644989a7393ed816ca02cfc9d089a.svg";
export { ForwardRef as ReactComponent };